// singleton class for the services data http calls to the API

import { BaseService } from './base-service';
import { getHTTPHeaders } from '../helpers/utils';

class SitesService extends BaseService {
    constructor() {
        super();
    }

    getSites(companyId, areaId) {
        return new Promise((resolve, reject) => {
            this.$http.get('site', {
                params: {
                    company_id: companyId,
                    area_id: areaId
                },
                headers: getHTTPHeaders().headers
            }
            )
                .then((response) => {
                    resolve(response.data.sites);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    updateSite(site, id) {
        return new Promise((resolve, reject) => {

            const formData = new FormData();
            let payload = {
                id: id,
                company_id: site.company_id,
                site_name: site.site_name,
                contact_no: site.contact_no,
                email: site.email,
                show_plates_manufacturer_id: site.show_plates_manufacturer_id,
                area_id: site.area_id,
                account_code: site.account_code,
                logo: site.logo,
                is_deleted: site.is_deleted
            }

            for (let key in payload) {
                formData.append(key, payload[key]);
            }
            formData.append('_method', 'PUT');

            this.$http.post('site/'+payload.id ,formData, getHTTPHeaders())
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });

        });
    }

    createSite(site) {
        return new Promise((resolve, reject) => {
            this.$http.post('site', {
                site: site
              },
              getHTTPHeaders()
            )
                .then((response) => {
                    if (response.data.success == true) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                })
                .catch ((err) => {
                    reject(err);
                });
        });
    }
}

export default new SitesService();